import React, { useContext, useEffect,useState } from 'react';
import { Link } from 'react-router-dom'
import PlanServices from '../../services/PlanServices';
import useAsync from '../../hooks/useAsync';
import {AuthContext} from '../../AuthContext';
import { Navigate } from 'react-router-dom';
import ComanServices from '../../services/ComanServices';
import UserServices from '../../services/UserServices';
import { ThemeToggle } from '../../components/ThemeToggle';
import './Home.css';

// Contact details shown in the Home page top bar.
const HOME_CONTACT_PHONE = '9414004245';
const HOME_CONTACT_EMAIL = 'manishk004245@gmail.com';

// About Me text. Profile fields saved in the admin "About" settings take priority; no
// qualifications are claimed here — they appear only if entered in the admin settings.
const ABOUT_FALLBACK = {
  name: 'Mr. Manish Khandelwal',
  role: 'Market practitioner · 25+ years in Indian financial markets',
  intro: [
    'Manish Khandelwal is one of the first breed of commodity brokers in the country, with more than 25 years of hands-on experience in Indian equity, derivatives and commodity markets. Having traded through several full market cycles — bull runs, sharp corrections and periods of extreme volatility — he has built a disciplined, data-driven approach to reading price action and option-chain activity.',
    'His work centres on understanding where large participants are positioned: open interest build-up, changes in option writing, and the support and resistance levels these create. That approach is the foundation of Option Trading Wala — tools that turn raw option-chain data into clear, actionable levels for everyday traders.',
    'He places risk management at the heart of every trade: defined stop-losses, position sizing matched to capital, and the patience to wait for high-probability setups instead of chasing the market.',
  ],
  pillars: [
    ['fa-line-chart', 'Market analysis', 'Price action, trend and index structure'],
    ['fa-table', 'Option-chain reading', 'OI, OI change, PCR and writer positioning'],
    ['fa-crosshairs', 'Trading strategies', 'Support / resistance and reversal setups'],
    ['fa-shield', 'Risk management', 'Stop-losses, position sizing, discipline'],
  ],
  experience: '25+ years of active trading and broking',
  expertise: 'Equity derivatives, index options and commodities',
};

const QUICK_ACTIONS = [
  { to: '/optionchain', title: 'Live Option Chain', sub: 'Real-time chain with S/R', icon: 'fa-link', tone: 'blue' },
  { to: '/backtester', title: 'Back Tester', sub: 'Historical option chain', icon: 'fa-history', tone: 'teal' },
  { to: '/power-stocks', title: 'Power Stocks', sub: 'Stock screener', icon: 'fa-bolt', tone: 'orange' },
  { to: '/strong-sr-stock', title: 'Triple S/R', sub: 'Strong support / resistance', icon: 'fa-align-justify', tone: 'green' },
];
const CONNECT_LINKS = [
  ['img/chain-hyperlink.svg', 'Option Chain'],
  ['img/chain-hyperlink-youtube.svg', 'YouTube'],
  ['img/chain-hyperlink-email.svg', 'Email'],
  ['img/chain-hyperlink-telegram.svg', 'Telegram'],
];

function Home() {
  const [plan ,setPlan] = useState([])
  const [contact ,setContact] = useState()
  const [about ,setAbout] = useState()
  const { data, error, isLoading, run } = useAsync(PlanServices.getAllPlan);
  
  const { isLoggedIn } = useContext(AuthContext);

  useEffect(() => {
    ComanServices.getContact().then(response => {
      console.log(response)
      setContact(response?.data)
    }).catch((error) => {
      console.log(error)
    })

    ComanServices.getAbout().then(response => {
      setAbout(response?.data)

    }).catch((error) => {
      console.log(error)
    })
  }, [])
  
  useEffect(() => {
  if (Array.isArray(data)) {
    setPlan(data);
  } else {
    console.error(' received:');
  }
},[data])
  const handlePlan = (plan) => {
    const body = {
      "planId": plan._id,
       "authorization"  : `Berrar ${localStorage.getItem("token")}`
  }

  PlanServices.createSubscriptionByUser(body).then(response => {
        alert("Plan subscribed successfully");
  })
}
  return (
   <>
      <div>
        <div className="hp-page">
          {/* ======== Top bar: menu, logo, contact, socials, theme, login ======== */}
          <header className="hp-topbar">
            <div className="toggle-btn-outer hp-menu">
              <button type="button" aria-label="Open menu"><i className="fa fa-bars" /></button>
            </div>
            <Link to="/" className="hp-logo"><img src="img/header-logo.svg" alt="Option Trading Wala" /></Link>
            <div className="hp-topbar-contact">
              <a href={`tel:+91${HOME_CONTACT_PHONE}`}><i className="fa fa-phone" /> +91 {HOME_CONTACT_PHONE}</a>
              <a href={`mailto:${HOME_CONTACT_EMAIL}`}><i className="fa fa-envelope" /> {HOME_CONTACT_EMAIL}</a>
            </div>
            <div className="hp-topbar-actions">
              <ThemeToggle className="shrink-0" />
              {!isLoggedIn && (
                <>
                  <Link to="#" className="hp-btn hp-btn-ghost" data-bs-toggle="modal" data-bs-target="#loginModel">Login</Link>
                  <Link to="#" className="hp-btn hp-btn-primary" data-bs-toggle="modal" data-bs-target="#signupModel">Signup</Link>
                </>
              )}
            </div>
          </header>

          <main className="hp-main">
            {/* ======== Welcome ======== */}
            <section className="hp-card hp-hero">
              <div>
                <span className="hp-eyebrow"><i className="fa fa-line-chart" /> Option chain analytics</span>
                <h1>Welcome to OTW <span>– Option Trading Wala</span></h1>
                <p>25 years of trust | 1 Cr+ Happy customers. Live option chain, support / resistance, power stocks and backtesting in one place.</p>
                <div className="hp-hero-cta">
                  <Link to="/optionchain" className="hp-btn hp-btn-primary hp-btn-lg"><i className="fa fa-table" /> Open Option Chain</Link>
                  <Link to="/backtester" className="hp-btn hp-btn-ghost hp-btn-lg"><i className="fa fa-history" /> Back Tester</Link>
                </div>
              </div>
              <img className="hp-hero-img" src="img/banner-img.gif" alt="Option chain dashboard" loading="lazy" />
            </section>

            {/* ======== Quick actions ======== */}
            <section className="hp-actions">
              {QUICK_ACTIONS.map((a) => (
                <Link key={a.to} to={a.to} className="hp-card hp-action">
                  <span className={`hp-action-icon hp-tone-${a.tone}`}><i className={`fa ${a.icon}`} /></span>
                  <span className="hp-action-text"><strong>{a.title}</strong><small>{a.sub}</small></span>
                  <i className="fa fa-chevron-right hp-action-go" />
                </Link>
              ))}
            </section>

            <div className="hp-grid-2">
              {/* ======== Tools (same popups as before) ======== */}
              <section className="hp-card">
                <div className="hp-section-head"><h2>Quick Tools</h2></div>
                <div className="hp-tools">
                  <button className="hp-tool" data-bs-toggle="modal" data-bs-target="#settingModel">
                    <img src="img/setting-img.svg" alt="" loading="lazy" /><span>Setting</span>
                  </button>
                  <button className="hp-tool" data-bs-toggle="modal" data-bs-target="#disclaimerModel">
                    <img src="img/disclaimer-img.svg" alt="" loading="lazy" /><span>Disclaimer</span>
                  </button>
                  <button className="hp-tool">
                    <img src="img/clear-data-cache-img.svg" alt="" loading="lazy" /><span>Clear Data / Cache</span>
                  </button>
                  <button className="hp-tool">
                    <img src="img/share-otw-img.svg" alt="" loading="lazy" /><span>Daily Analysis</span>
                  </button>
                  <button className="hp-tool" data-bs-toggle="modal" data-bs-target="#notificationModel">
                    <img src="img/notification-img.svg" alt="" loading="lazy" /><span>Notification</span>
                  </button>
                </div>
              </section>

              {/* ======== Help & support ======== */}
              <section className="hp-card">
                <div className="hp-section-head"><h2>Help &amp; Support</h2></div>
                <p className="hp-muted hp-mb">For any query or support, reach us on:</p>
                <a className="hp-contact-row" href={`tel:+91${HOME_CONTACT_PHONE}`}>
                  <span className="hp-action-icon hp-tone-blue"><i className="fa fa-phone" /></span>
                  <span className="hp-action-text"><strong>+91 {HOME_CONTACT_PHONE}</strong><small>Call us</small></span>
                  <i className="fa fa-chevron-right hp-action-go" />
                </a>
                <a className="hp-contact-row" href={`mailto:${HOME_CONTACT_EMAIL}`}>
                  <span className="hp-action-icon hp-tone-red"><i className="fa fa-envelope" /></span>
                  <span className="hp-action-text"><strong>{HOME_CONTACT_EMAIL}</strong><small>Email support</small></span>
                  <i className="fa fa-chevron-right hp-action-go" />
                </a>
                <div className="hp-social">
                  <Link to={contact?.whatsApp} aria-label="WhatsApp"><i className="fa fa-whatsapp" /></Link>
                  <Link to={contact?.faceBook} aria-label="Facebook"><i className="fa fa-facebook" /></Link>
                  <Link to={contact?.whatsApp} aria-label="Twitter"><i className="fa fa-twitter" /></Link>
                  <Link to={contact?.linkdin} aria-label="LinkedIn"><i className="fa fa-linkedin" /></Link>
                  <Link to={contact?.whatsApp} aria-label="YouTube"><i className="fa fa-youtube-play" /></Link>
                  <Link to={contact?.whatsApp} aria-label="Telegram"><i className="fa fa-paper-plane" /></Link>
                  <Link to={contact?.instagram} aria-label="Instagram"><i className="fa fa-instagram" /></Link>
                </div>
              </section>
            </div>

            {/* ======== About ======== */}
            <section className="hp-card hp-about">
              {about?.image && <img src={process.env.REACT_APP_URL + about?.image} alt={about?.Name || 'About'} loading="lazy" />}
              <div>
                <span className="hp-eyebrow">About Me</span>
                <h2>{about?.Name ? `Mr. ${about.Name}` : ABOUT_FALLBACK.name}</h2>
                <p className="hp-about-role">{ABOUT_FALLBACK.role}</p>
                {ABOUT_FALLBACK.intro.map((para, i) => <p key={i} className="hp-about-intro">{para}</p>)}
                <ul className="hp-about-pillars">
                  {ABOUT_FALLBACK.pillars.map(([icon, title, text]) => (
                    <li key={title}>
                      <span className="hp-action-icon hp-tone-blue"><i className={`fa ${icon}`} /></span>
                      <span><strong>{title}</strong><small>{text}</small></span>
                    </li>
                  ))}
                </ul>
                {/* Profile details from the admin "About" settings; only filled-in fields are shown. */}
                <dl className="hp-about-list">
                  <div><dt>Experience</dt><dd>{about?.experience || ABOUT_FALLBACK.experience}</dd></div>
                  <div><dt>Main area of expertise</dt><dd>{about?.experties || ABOUT_FALLBACK.expertise}</dd></div>
                  {about?.occupation && <div><dt>Occupation</dt><dd>{about.occupation}</dd></div>}
                  {about?.qulafication && <div><dt>Qualifications</dt><dd>{about.qulafication}</dd></div>}
                  {about?.website && <div><dt>Website</dt><dd>{about.website}</dd></div>}
                </dl>
                <Link to="about-us.html" className="hp-btn hp-btn-ghost">Know More</Link>
              </div>
            </section>

            {/* ======== Plans ======== */}
            <section className="hp-plans-wrap">
              <div className="hp-section-head hp-center">
                <div><h2>Choose your plan</h2><small>Please select a plan to continue · prices include GST (18%)</small></div>
              </div>
              <div className="hp-plans">
                {plan?.map((p, index) => (
                  <article key={p?._id || index} className="hp-card hp-plan">
                    <h3>{p?.name}</h3>
                    <div className="hp-plan-price"><span>₹</span>{p?.price}</div>
                    <small className="hp-muted">For {p?.validity} days including GST (18%)</small>
                    <ul>
                      <li><i className="fa fa-check-circle" /> Faster Data Refersh</li>
                      <li><i className="fa fa-check-circle" /> Include all Features of OTW</li>
                      <li><i className="fa fa-check-circle" /> Add free Experence</li>
                      <li><i className="fa fa-check-circle" /> Includes all scripts and indices</li>
                      <li><i className="fa fa-check-circle" /> Live Webinar Access</li>
                    </ul>
                    <button onClick={() => handlePlan(p)} className="hp-btn hp-btn-primary hp-btn-block">Subscribe</button>
                  </article>
                ))}
              </div>
            </section>

            {/* ======== Connect ======== */}
            <section className="hp-card">
              <div className="hp-section-head"><div><h2>Connect &amp; Features</h2><small>Online trading and investing in the market does not have to be boring.</small></div></div>
              <div className="hp-connect">
                {CONNECT_LINKS.map(([src, label]) => (
                  <div key={label} className="hp-connect-item">
                    <img src={src} alt="" loading="lazy" />
                    <span>{label}</span>
                  </div>
                ))}
              </div>
            </section>
          </main>
        </div>
        {/* <section class="get-in touch-section mb-70">
        <div class="container">
            <div class="title">
                <h2 class="heading">Get in Touch at <span>Any Times</span></h2>
                <p class="sub-heading">Do not Hesitate to contact us with any queries.</p>
            </div>
            <div class="get-in-touch-section-inner">
                <div class="row align-items-center">
                    <div class="col-md-5">
                        <div class="get-in-touch-details">
                            <div class="get-in-touch-details-inner">
                                <h4>Address</h4>
                                <div class="get-in-touch-list">
                                    <div class="get-in-touch-icon">
                                        <span><i class="fa fa-map-marker"></i></span>
                                    </div>
                                    <Link to="#"> 4th Floor, Baid House,1, Tara Nagar, Ajmer Road ,Jaipur - 302 006 Rajasthan, India</Link>
                                </div>
                            </div>
                            <div class="get-in-touch-details-inner">
                                <h4>Phone</h4>
                                <div class="get-in-touch-list">
                                    <div class="get-in-touch-icon">
                                        <span><i class="fa fa-phone"></i></span>
                                    </div>
                                    <div>
                                        <Link to="tel:+91 9876543210">Call -  +91 9876543210</Link><br>
                                        <Link to="tel:+91 9876543210">Whatsapp - +91 98976543210</Link>
                                    </div>
                                </div>
                            </div>
                            <div class="get-in-touch-details-inner">
                                <h4>Email</h4>
                                <div class="get-in-touch-list">
                                    <div class="get-in-touch-icon">
                                        <span><i class="fa fa-envelope"></i></span>
                                    </div>
                                    <Link to="mailto:helpdesk@example.net"> helpdesk@example.net</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-7">
                        <div class="map-section text-end">
                            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3557.797947865437!2d75.7788587760942!3d26.909906860209908!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db4730bf5ad77%3A0x69bd4d23464a61e9!2sCivil%20Lines%20Metro%20Station%2C%20Elevated%20Ajmer%20Rd%2C%20Madrampur%2C%20Civil%20Lines%2C%20Jaipur%2C%20Rajasthan%20302006!5e0!3m2!1sen!2sin!4v1708688728797!5m2!1sen!2sin" width="640" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </section> */}
        {/* footer-section-start */}
     
        {/* footer-section-end */}
        {/* scroll to top  */}
        <div className="scroll_top">
          <Link to="javascript:void(0)" id="scroll-button" style={{display: 'none'}}><i className="fa fa-angle-up" /></Link>
        </div>
        {/* ======== Setting popup ======== */}
        <div className="modal fade" id="settingModel" tabIndex={-1} aria-labelledby="settingModelLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <h5 className="modal-title" id="settingModelLabel">Setting</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="setting-functionalty-outer popup-list">
                  <ul className="list-unstyled">
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/light-mode.svg" alt="icon" /></span>
                        <span>Light Mode</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input light-mode" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/highlight.svg" alt="icon" /></span>
                        <span>ITM &amp; OTM Highlight</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input itm-otm-highlight" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/screen-desktop.svg" alt="icon" /></span>
                        <span>Keep Screen Awake</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input keep-screen-awake" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/price-tag.svg" alt="icon" /></span>
                        <span>Show Future Price</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input show-future-price" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/top-so.svg" alt="icon" /></span>
                        <span>High Third Highest</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input high-third-highest" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/number-sign.svg" alt="icon" /></span>
                        <span>Show Numbers</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input show-numbers" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/table-column.svg" alt="icon" /></span>
                        <span>Reverse Table</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input reverse-table" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/percentage.svg" alt="icon" /></span>
                        <span>Prefer Percentage</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input prefer-percentage" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/show-qt.svg" alt="icon" /></span>
                        <span>Show QT in Lots</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input show-qt" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/trash.svg" alt="icon" /></span>
                        <span>Clear Data Cache</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input clear-data-cache" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== Search Nifty popup ======== */}
        <div className="modal fade" id="searchNiftyModel" tabIndex={-1} aria-labelledby="searchNiftyModelLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content modal-bg-light-green">
              <div className="modal-body py-4 px-4">
                <form className="search-field-container">
                  <div className="form-input">
                    <input type="search" name="Search Nifty" className="form-control" placeholder="Search Stock/Index" />
                  </div>
                </form>
                <div className="nifty-index-list">
                  <ul className="list-unstyled">
                    <li><button>Banknifty</button></li>
                    <li><button>Finnifty</button></li>
                    <li><button>Nifty_Mid_Select</button></li>
                    <li><button>Nifty</button></li>
                    <li><button>Naturalgas</button></li>
                    <li><button>Crudeoil</button></li>
                    <li><button>Usdinr</button></li>
                    <li><button>Sensex</button></li>
                    <li><button>bankex</button></li>
                    <li><button>Aartiind</button></li>
                    <li><button>Sensex</button></li>
                    <li><button>bankex</button></li>
                    <li><button>Aartiind</button></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== OI Percentage Graph popup ======== */}
        <div className="modal fade " id="oichartModel" tabIndex={-1} aria-labelledby="oichartModelLabel" aria-hidden="true ">
          <div className="modal-dialog ai-chart modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <h5 className="modal-title" id="oichartModelLabel">OI Charts</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <ul className="nav nav-pills ai-chart-nav mb-3" id="pills-tab" role="tablist">
                  <li className="nav-item ai-chart-item" role="presentation">
                    <button className="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true">OI Change</button>
                  </li>
                  <li className="nav-item ai-chart-item" role="presentation">
                    <button className="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false">OI Graph</button>
                  </li>
                  <li className="nav-item ai-chart-item" role="presentation">
                    <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">Volume</button>
                  </li>
                  <li className="nav-item ai-chart-item" role="presentation">
                    <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">PCR</button>
                  </li>
                  <li className="nav-item ai-chart-item" role="presentation">
                    <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">CE BuildUp</button>
                  </li>
                  <li className="nav-item ai-chart-item" role="presentation">
                    <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">PE BuildUp</button>
                  </li>
                </ul>
                <div className="oi-chart-btn-inner">
                  <ul className="list-unstyled d-flex justify-content-center align-items-center">
                    <li> <button> <span />OI Change PE-CE</button></li>
                    <li> <button> <span className="oi-chart-green" />OI Change PE</button></li>
                    <li> <button> <span className="oi-chart-red" />OI Change CE</button></li>
                  </ul>
                </div>
              </div>
              <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                  <div className="ai-chart-img">
                    <img src="img/oi-percentage-graph.svg" alt="chart" />
                  </div>
                </div>
                <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                  <div className="ai-chart-img">
                    <img src="img/oi-percentage-graph.svg" alt="chart" />
                  </div>
                </div>
                <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                  <div className="ai-chart-img">
                    <img src="img/oi-percentage-graph.svg" alt="chart" />
                  </div>
                </div>
                <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                  <div className="ai-chart-img">
                    <img src="img/oi-percentage-graph.svg" alt="chart" />
                  </div>
                </div>
                <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                  <div className="ai-chart-img">
                    <img src="img/oi-percentage-graph.svg" alt="chart" />
                  </div>
                </div>
                <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                  <div className="ai-chart-img">
                    <img src="img/oi-percentage-graph.svg" alt="chart" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== OI Percentage Graph-1 popup ======== */}
        <div className="modal fade" id="oipercentage1Model" tabIndex={-1} aria-labelledby="oioipercentage1ModelLabel" aria-hidden="true ">
          <div className="modal-dialog ai-chart modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <h5 className="modal-title" id="disclaimerModelLabel">oipercentage1 Graph</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="oi-chart-btn-inner">
                  <ul className="list-unstyled d-flex justify-content-center align-items-center">
                    <li> <button> <span />Volume %</button></li>
                    <li> <button> <span className="oi-chart-wine" />OI %</button></li>
                    <li> <button> <span className="oi-chart-green" />OI Change %</button></li>
                  </ul>
                </div>
              </div>
              <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                  <div className="ai-chart-img">
                    <img src="img/oi-percentage-graph-1.svg" alt="chart" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== Combined Price Chart IV- popup ======== */}
        <div className="modal fade " id="CombinedpriceModel" tabIndex={-1} aria-labelledby="CombinedpriceModelLabel" aria-hidden="true ">
          <div className="modal-dialog ai-chart modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <h5 className="modal-title" id="CombinedpriceModel">Combined Price Chart</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="oi-chart-btn-inner">
                  <ul className="list-unstyled d-flex justify-content-center align-items-center">
                    <li> <button> <span className="oi-chart-lite-blue" />Combined Price</button></li>
                    <li> <button> <span className="oi-chart-green" />CE Price</button></li>
                    <li> <button> <span className="oi-chart-red" />PE Price</button></li>
                  </ul>
                </div>
              </div>
              <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                  <div className="ai-chart-img">
                    <img src="img/combined-price-chart-iv.svg" alt="chart" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== Combined Price Chart IV-1 popup ======== */}
        <div className="modal fade " id="futureBuildupModel" tabIndex={-1} aria-labelledby="futureBuildupModelLabel" aria-hidden="true ">
          <div className="modal-dialog ai-chart modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <h5 className="modal-title" id="futureBuildupModel">Future Buildup: Nifty</h5>
                <button type="button" className="info-table" data-bs-dismiss="modal" data-bs-target="#futureBuildupinfoModel"><i style={{fontSize: '24px'}} className="fa fa-info-circle" /></button>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="oi-chart-btn-inner">
                  <ul className="list-unstyled d-flex justify-content-center align-items-center">
                    <li> <button> <span className="oi-chart-lite-blue" />Future Price</button></li>
                    <li> <button> <span className="oi-chart-wine" />Future OI Price</button></li>
                  </ul>
                </div>
              </div>
              <div className="tab-content" id="pills-tabContent">
                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                  <div className="ai-chart-img">
                    <img src="img/combined-price-chart-iv-1.svg" alt="chart" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== info-table popup ======== */}
        <div className="modal fade " id="futureBuildupinfoModel" tabIndex={-1} aria-labelledby="futureBuildupinfoModelLabel" aria-hidden="true ">
          <div className="modal-dialog ai-chart modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-body">
                <div className="oi-chart-btn-inner  ">
                  <table className="info-table  w-100 ">
                    <tbody><tr className="info-table-row ">
                        <th className="info-table-heading">Price</th>
                        <th className="info-table-heading">OI or OI CHNG</th>
                        <th className="info-table-heading">Result</th>
                        <th className="info-table-heading">Meaning</th>
                        <th className="info-table-heading">Option Trade</th>
                      </tr>
                      <tr className="info-table-row-1">
                        <td className="info-table-data">Up</td>
                        <td className="info-table-data">Up</td>
                        <td className="info-table-data">Long Buildup</td>
                        <td className="info-table-data">Strong Bullish</td>
                        <td className="info-table-data">CE Buy</td>
                      </tr>
                      <tr className="info-table-row-1">
                        <td className="info-table-data">Up</td>
                        <td className="info-table-data">Up</td>
                        <td className="info-table-data">Long Buildup</td>
                        <td className="info-table-data">Strong Bullish</td>
                        <td className="info-table-data">CE Buy</td>
                      </tr>
                      <tr className="info-table-row-1">
                        <td className="info-table-data">Up</td>
                        <td className="info-table-data">Up</td>
                        <td className="info-table-data">Long Buildup</td>
                        <td className="info-table-data">Strong Bullish</td>
                        <td className="info-table-data">CE Buy</td>
                      </tr>
                      <tr className="info-table-row-1">
                        <td className="info-table-data">Up</td>
                        <td className="info-table-data">Up</td>
                        <td className="info-table-data">Long Buildup</td>
                        <td className="info-table-data">Strong Bullish</td>
                        <td className="info-table-data">CE Buy</td>
                      </tr>
                    </tbody></table>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== volume-chart popup ======== */}
        <div className="modal fade " id="volumeChartModel" tabIndex={-1} aria-labelledby="volumeChartModelLabel" aria-hidden="true ">
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="volume-chart-inner  ">
                  <h3><strong>Possible Reversal For</strong> : 21500</h3>
                  <h4><strong>Resistance:</strong> 21490.91 <button className="volume-copy-btn" data-bs-target="#valueCopyModel" data-bs-dismiss="modal"><i className="fa fa-clone" aria-hidden="true" /></button> </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== volume-chart-1 popup ======== */}
        <div className="modal fade valueCopy" id="valueCopyModel" tabIndex={-1} aria-labelledby="valueCopyModelLabel" aria-hidden="true ">
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="volume-chart-inner volume-chart-1  ">
                  <h3>Value Copied to clipboard</h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== LTP Calculator popup ======== */}
        <div className="modal fade " id="LPTcalculatorModel" tabIndex={-1} aria-labelledby="LPTcalculatorModelLabel" aria-hidden="true ">
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <h5 className="modal-title" id="LPTcalculatorModelLabel">LTP calculator 22000 CE</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <input type="text" placeholder="Target spot price" className="ltp-calculator-field" />
                <div className="volume-chart-inner ltp-calculator-content ">
                  <h3><strong>Buy Price: </strong> - 3216.09</h3>
                  <h4><strong>SL: </strong> - 3219.09</h4>
                  <h5><strong>Target: </strong> - 6527.25</h5>
                  <p>This is a rough estimate, calculation is based on delta.
                    Please use your own judgement and do not trade based on
                    this alone.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== free-user popup ======== */}
        <div className="modal fade " id="freeUserModel" tabIndex={-1} aria-labelledby="freeUserModelLabel" aria-hidden="true ">
          <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <h5 className="modal-title" id="freeUserModelLabel">Upgrade to Pro Plan for <br />
                  faster data update</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="volume-chart-inner  ">
                  <div className="free-user-content">
                    <p>As a free user, you will get delayed data by 3 minutes.</p>
                    <p>Upgrade to Pro Plan to get faster data updates and <br />
                      access to all features.</p>
                  </div>
                  <div className="free-user-check">
                    <h2><i style={{color: '#25D366'}} className="fa fa-check-circle-o" aria-hidden="true"> </i> Fast data
                      updates</h2>
                    <h2><i style={{color: '#25D366'}} className="fa fa-check-circle-o" aria-hidden="true"> </i> Ads free
                      experience</h2>
                    <h2><i style={{color: '#25D366'}} className="fa fa-check-circle-o" aria-hidden="true"> </i> Access to
                      all features</h2>
                    <h2><i style={{color: '#25D366'}} className="fa fa-check-circle-o" aria-hidden="true"> </i> Access to
                      all future features</h2>
                    <h2><i style={{color: '#25D366'}} className="fa fa-check-circle-o" aria-hidden="true"> </i> Premium
                      support</h2>
                  </div>
                  <div className="free-user-btn-content d-flex justify-content-center align-items-center">
                    <button className="free-user-btn me-3">Continue as free user</button>
                    <button className="free-user-btn btn-red">Subscribe to Pro Plan</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== Search Nifty popup ======== */}
        <div className="modal fade" id="searchNiftyModel" tabIndex={-1} aria-labelledby="searchNiftyModelLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content modal-bg-light-green">
              <div className="modal-body py-4 px-4">
                <form className="search-field-container">
                  <div className="form-input">
                    <input type="search" name="Search Nifty" className="form-control" placeholder="Search Stock/Index" />
                  </div>
                </form>
                <div className="nifty-index-list">
                  <ul className="list-unstyled">
                    <li><button>Banknifty</button></li>
                    <li><button>Finnifty</button></li>
                    <li><button>Nifty_Mid_Select</button></li>
                    <li><button>Nifty</button></li>
                    <li><button>Naturalgas</button></li>
                    <li><button>Crudeoil</button></li>
                    <li><button>Usdinr</button></li>
                    <li><button>Sensex</button></li>
                    <li><button>bankex</button></li>
                    <li><button>Aartiind</button></li>
                    <li><button>Sensex</button></li>
                    <li><button>bankex</button></li>
                    <li><button>Aartiind</button></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== Update Profile popup ======== */}
        <div className="modal fade" id="updateModel" tabIndex={-1} aria-labelledby="updateModelLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <h5 className="modal-title" id="disclaimerModelLabel">Update Profile</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body py-4 px-5">
                <div className="header-logo text-center">
                  <Link to="#"><img src="img/header-logo.svg" alt="logo" /></Link>
                </div>
                <div className="login-form-outer">
                  <form>
                    <div className="form-input mb-3">
                      <input type="text" name="Name" className="form-control" placeholder="Name" />
                    </div>
                    <div className="form-input mb-3">
                      <input type="text" name="State" className="form-control" placeholder="State" />
                    </div>
                    <div className="form-input mb-3">
                      <input type="text" name="District" className="form-control" placeholder="District" />
                    </div>
                    <div className="form-input mb-3">
                      <input type="text" name="City" className="form-control" placeholder="City" />
                    </div>
                    <div className="form-input mb-3">
                      <input type="text" name="Phone" className="form-control" placeholder="Phone" />
                    </div>
                    <div className="update-btn-outer">
                      <button type="button" className="site-btn btn-blue-o" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
                      <button type="submit" className="update-btn site-btn btn-blue">Update</button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== Delete Account Warning popup ======== */}
        <div className="modal fade" id="deleteACModel" tabIndex={-1} aria-labelledby="deleteACModelLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content modal-bg-light-green">
              <div className="modal-body py-4 px-5 text-center">
                <h4>Warning !!</h4>
                <p className="desc my-2">Are you sure you want to delete your account?</p>
                <p className="desc mb-2">This action cannot be done.</p>
                <p className="desc mb-2">All your data will be deleted.</p>
                <div className="donate-btn-grp text-center py-4">
                  <button className="site-btn btn-blue delete-btn" data-bs-toggle="modal" data-bs-target="#deleteACModel">Cancel</button>
                  <button className="site-btn btn-red delete-btn">Delete Account</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== Notification popup ======== */}
        <div className="modal fade" id="notificationModel" tabIndex={-1} aria-labelledby="notificationModelLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-header">
                <h5 className="modal-title" id="notificationModelLabel">Notification Setting</h5>
                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
              </div>
              <div className="modal-body">
                <div className="notification-functionalty-outer popup-list">
                  <ul className="list-unstyled">
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/stock-ticker.svg" alt="icon" /></span>
                        <span>Stocks</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input stocks" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/data-collection.svg" alt="icon" /></span>
                        <span>Indices</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input indices" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/currency.svg" alt="icon" /></span>
                        <span>Currency</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input currency" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                    <li>
                      <div className="popup-list-title">
                        <span><img src="img/stock_mcx.svg" alt="icon" /></span>
                        <span>MCX</span>
                      </div>
                      <div className="toggle-status">
                        <div className="form-check form-switch">
                          <input className="form-check-input mcx" type="checkbox" id="flexSwitchCheckChecked" defaultChecked />
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
       
        {/* ======== Login popup ======== */}
     
      
        {/* forgot-password-number-popup */}
        <div className="modal fade " id="forget-password-numberModel" tabIndex={-1} aria-labelledby="forget-password-numberModelLabel" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered ">
            <div className="modal-content modal-bg-light-blue">
              <div className="modal-body px-5">
                <div className="login-form-outer">
                  <form>
                    <div className="form-input mb-3">
                      <label htmlFor="exampleFormControlInput1" className="form-label">New Password</label>
                      <input type="text" name="Email or Phone No" className="form-control" placeholder="**********" />
                    </div>
                    <div className="form-input mb-3">
                      <label htmlFor="exampleFormControlInput1" className="form-label">Confirm Password</label>
                      <input type="text" name="Email or Phone No" className="form-control" placeholder="**********" />
                    </div>
                    <div className="forget-popup-btn">
                      <button type="submit" className="submit-btn submit-btn-number-popup"> <Link to="javascript:void(0);" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#loginModel">Submit</Link></button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* ======== Signup popup ======== */}
        
      </div>
   </>
  )
}

export default Home